import UpdateFormHead from "components/subHead/updateFromHead";
import { useTranslation } from "react-i18next";
import BaseInfForm from "../baseInfForm";
import {
  UPDATE_ADDINF_FORM_ID_ROOM_OPTION,
  UPDATE_BASE_FORM_ID_ROOM_OPTION,
} from "components/constent";
import { useGetData } from "../service";
import MultiFormHead from "components/subHead/multiFormHead";
import MultilingualForm from "../multilingualForm";
import useMultiLangStore from "store/multiLang";
import { useOptionAddInfContext } from "../context";
import { useEditedLang, useSetBaseInf } from "../handlers";
import NoInf from "components/noInf";

export default function OptionAddInfUpdate() {
  const { t } = useTranslation();
  const { getDefaultValue } = useOptionAddInfContext();
  const multiLang = useMultiLangStore((state) => state.multiLang);

  const { baseInf, addInf } = useGetData({ modalNm: "update" });

  const savedLangs =
    addInf.length !== 0 ? addInf.map((inf: any) => inf.langCd) : [];

  const baseValue = getDefaultValue(multiLang) || {};

  const { setBasetInf } = useSetBaseInf();
  const { editedLang } = useEditedLang();

  return (
    <>
      {/* 기본정보 */}
      <UpdateFormHead
        title={t("row_ttl_default")}
        formId={UPDATE_BASE_FORM_ID_ROOM_OPTION}
      />

      {/* 로딩 페이지 추가 */}
      {!baseInf && (
        <BaseInfForm
          baseInf={undefined}
          formTyp={"update"}
          formId={UPDATE_BASE_FORM_ID_ROOM_OPTION}
        />
      )}
      {baseInf && (
        <BaseInfForm
          baseInf={baseInf}
          formTyp={"update"}
          formId={UPDATE_BASE_FORM_ID_ROOM_OPTION}
        />
      )}

      {/* 다국어 정보 */}
      <MultiFormHead
        title={t("row_ttl_add_inf")}
        formId={
          UPDATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + (multiLang || savedLangs[0])
        }
        savedLangs={savedLangs}
        setBasetInf={setBasetInf}
        editedLang={editedLang}
      />
      <div>
        {/* 등록된 정보가 없을 시 기본 폼 제공 */}
        {!multiLang && addInf.length === 0 && (
          <NoInf sub="언어버튼을 클릭하여 폼을 추가하여 주세요." />
        )}

        {addInf.length !== 0 && (
          <>
            {addInf.map((inf: any) => {
              return (
                <MultilingualForm
                  key={inf?.langCd}
                  inf={
                    inf.langCd === multiLang
                      ? {
                          ...inf,
                          ...baseValue,
                        }
                      : inf
                  }
                  updateAble="true"
                  formTyp={"update"}
                  formId={UPDATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + inf.langCd}
                />
              );
            })}
          </>
        )}
        {!!multiLang && !savedLangs.includes(multiLang) && (
          <MultilingualForm
            inf={{
              langCd: multiLang,
              ...baseValue,
            }}
            formTyp={"create"}
            formId={
              UPDATE_ADDINF_FORM_ID_ROOM_OPTION +
              "-" +
              (multiLang || savedLangs[0])
            }
          />
        )}
      </div>
    </>
  );
}

{
  /*추가정보  */
}
{
  /* <UpdateFormHead
        title={t("row_ttl_add_inf")}
        formId={UPDATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + multiLang}
        savedLangs={savedLangs}
        sub={addInf.length === 0 ? "등록된 추가정보가 없습니다." : ""}
      />
      <div>
        {addInf.length !== 0 && (
          <>
            {addInf.map((inf: any) => {
              return (
                <BaseAddInfForm
                  key={inf.langCd}
                  inf={inf}
                  updateAble="true"
                  formTyp={"update"}
                />
              );
            })}
          </>
        )}
      </div>

      {addInf.length === 0 &&
        langs.map((lang: any) => {
          return (
            <BaseAddInfForm
              key={lang.langCd}
              inf={{
                langCd: lang.code,
              }}
              updateAble="true"
              formTyp={"update"}
            />
          );
        })} */
}
